export type ServiceChapter = {
  id: string;
  eyebrow: string;
  label: string;
  title: string;
  body: string;
  note: string;
  image: string;
  imagePosition: string;
  surface: string;
  accent: string;
  href: string;
};

export const serviceChapters: ServiceChapter[] = [
  {
    id: "agency",
    eyebrow: "Services / 01",
    label: "Branding & identity",
    title: "Strategy & identity in one distinctive brand language.",
    body: "We bring strategy, visual identity and creative direction into one cohesive system, shaping a brand presence that stands apart, builds recognition and leaves a lasting impression.",
    note: "Distinctive brands are built through clarity, consistency and intentional design.",
    image: "/static/venuex/content/service-branding.webp",
    imagePosition: "center 26%",
    surface: "#f0e7da",
    accent: "var(--venuex-brand-sand)",
    href: "/service/luxury-branding/",
  },
  {
    id: "systems",
    eyebrow: "Services / 02",
    label: "Websites & digital solutions",
    title: "Design, function & technology built to work as one.",
    body: "We design responsive websites, e-commerce platforms and tailored digital solutions that combine aesthetics, functionality and performance - creating seamless experiences across every screen.",
    note: "Great digital experiences feel effortless when design and technology work as one.",
    image: "/static/venuex/content/service-websites.webp",
    imagePosition: "center center",
    surface: "#d9d8d4",
    accent: "var(--venuex-brand-mocha)",
    href: "/service/digital-experiences/",
  },
  {
    id: "founder",
    eyebrow: "Services / 03",
    label: "Digital marketing & growth",
    title: "Smart strategy & consistent presence create measurable growth.",
    body: "We connect digital marketing, social media management, SEO, automations, hosting and technical support into one coordinated system that strengthens your presence and supports long-term growth.",
    note: "Sustainable growth begins with strategy, consistency and continuous support.",
    image: "/static/venuex/content/service-digital-growth.webp",
    imagePosition: "44% center",
    surface: "#d9ccb7",
    accent: "var(--venuex-brand-olive)",
    href: "/service/growth-systems/",
  },
  {
    id: "experience",
    eyebrow: "Services / 04",
    label: "Events & experiences",
    title: "Concept, planning & execution come together in one seamless experience.",
    body: "We bring concept development, planning, production, styling and coordination together to deliver seamless corporate, social and destination events. From the first idea to the final guest experience.",
    note: "Lasting impressions are created through intentional design and thoughtful details.",
    image: "/static/venuex/content/service-events-experiences.webp",
    imagePosition: "center 54%",
    surface: "#d5c5b1",
    accent: "var(--venuex-brand-mocha)",
    href: "/service/events-experiences/",
  },
];
